function CoreUtils() {
    this.equal_height_rows = function (offset) {
        /*if ( offset === undefined ) {
            offset = 0;
        }
        $('.row_content_container.isediting_row').each(function () {
            var max_height = 200;
            $(this).children('[class^="col-"]').each(function () {
                $(this).css('min-height', 0);
                if ( $(this).height() > max_height ) {
                    max_height = $(this).height();
                }
            });
            $(this).children('[class^="col-"]').each(function () {
                $(this).css('min-height',(max_height+offset) + 'px');
            });
        });*/
    };
    this.adjust_editor_header_spacer = function () {
        //console.log("setting header height");
        $('.core-header-spacer').css('height', $('.core-header').outerHeight());
    };
    this.whichChild = function (elem){
        // TODO: on NEW add returns wrong index - on column change works correctly
        var  i= -1;
        while((elem=elem.previousSibling)!=null) ++i;
        return i;
    };
    this.showNoComponentsMessage = function () {
    };
    this.reorderLists = function () {
        var jsonData = {};
        jsonData.updateList = [];
        /*var order = sortable.toArray();
         console.log(sortable);
         console.log(order);
         localStorage.setItem(sortable.options.group.name, order.join('|'));*/
        [].forEach.call(document.querySelectorAll('.admin_row>[class^="col-md-"]'), function (column) {
            /**
             *    GET COLUMN INDEX
             */
            var index = Array.prototype.indexOf.call(column.parentNode.children, column);

            /**
             *     OUTPUT COLUMN AND ROW
             */
            //console.log("Row " + column.parentNode.dataset.rowId + ", index " + index + " contains...");

            /**
             *    LOOP THROUGH CHILDREN OF COLUMN
             */
            var order = 0;
            [].forEach.call(column.children, function (component) {
                if ((" " + component.className + " ").replace(/[\n\t]/g, " ").indexOf('core6_component') > -1) {
                    //console.log("---- Component ID " + component.dataset.componentId + " is in position " + order);
                    jsonData.updateList.push({
                        "row": column.parentNode.dataset.rowId,
                        "columnIndex": index,
                        "component_id": component.dataset.componentId,
                        "component_order": order
                    });
                    order++;
                }
            });
        });

        //console.log(jsonData);

        $.ajax({
            url: '/api/components/update/ordering',
            type: 'PATCH',
            data: {jsonData: jsonData, _method: "PATCH"},
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
                xhr.setRequestHeader('Authorization', 'Bearer ' + document.getElementById('API_TOKEN').value);
            },
            success: function (res) {
                //console.log("Received " + res);
                //Core6Utils.showNoComponentsMessage();
                //Core6Utils.equal_height_rows();
            }
        });
    };

    this.getCoords = function (elem) {
        var box = elem.getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var top  = box.top +  scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        return { elemTop: Math.round(top), elemLeft: Math.round(left) };
    };
}

self.Core6Utils = new CoreUtils();
//Core6Utils.equal_height_rows();
//Core6Utils.showNoComponentsMessage();
Core6Utils.adjust_editor_header_spacer();


// WEBPACK FOOTER //
// ./resources/assets/js/core6/utils.js